<template>
    <div>
        <div class="article-list__filter">
            <div class="article-list__category "
                 :class="filterDropDownIsOpen ? 'article-list__category--is-open' : 'article-list__category--is-closed'"
                 @click="filterDropDownIsOpen = !filterDropDownIsOpen" v-show="!hideArticleCategories">
                <div class="article-list__category-button">
                    <span class="article-list__category-label">{{ filterByText.toUpperCase() }}</span>
                    <span class="article-list__category-current">{{ selectedCategory.name.toUpperCase() }}</span>
                    <span class="article-list__category-arrow"></span>
                </div>
                <ul class="article-list__category-choices">
                    <li
                        v-for="(item, index) in allCategories"
                        :class="`article-list__category-button ${item.slug}`"
                        :key="index"
                        :name="item.slug"
                        @click.prevent="
                        selectCategory(item);
                        applyFilter(item.term_id);
                        "
                    >
                        {{ item.name.toUpperCase() }}
                    </li>
                </ul>
            </div>
            <!-- <div class="article-list__sorting  "
                 :class="sortDropDownIsOpen ? 'article-list__sorting--is-open' : 'article-list__sorting--is-closed'"
                 @click="sortDropDownIsOpen = !sortDropDownIsOpen">
                <div class="article-list__sorting-button">
                    <span class="article-list__sorting-label">{{ sortByText }}</span>
                    <span class="article-list__sorting-current">{{ sortedBy }}</span>
                    <span class="article-list__sorting-arrow"></span>
                </div>
                <ul id="article-sorting" class="article-list__sorting-choices">
                    <li @click="sortBy('post-date');">{{ dateAddedText }}</li>
                    <li @click="sortBy('order-popular'); sortDir = !sortDir;">{{ popularityText }}</li>
                </ul>
            </div> -->
        </div>
        <div class="article-list__posts-container">
            <div class="article-list__posts-display">
                <section
                    v-for="(post, index) in filteredPosts"
                    :key="index"
                >
                    <div v-if="thumbnailOverlay" class="article-list__posts-display-overlay"></div>
                    <picture>
                        <source :srcset="post.srcset" :sizes="post.sizes"/>
                        <img
                            loading="lazy"
                            :src="post.src"
                            :width="post.width"
                            :height="post.height"
                            :sizes="post.sizes"
                            :alt="post.alt"
                        />
                    </picture>
                    <div class="article-list__posts-display-content">
                        <svg width="40px" height="2px" viewBox="0 0 40 2" version="1.1"
                             xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g stroke="none" stroke-width="2" fill="none" fill-rule="evenodd">
                                <g transform="translate(-20.000000, -916.000000)" fill="#fff">
                                    <g transform="translate(20.000000, 904.000000)">
                                        <g>
                                            <rect x="0" y="12" width="40" height="2"></rect>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                        <div class="h6">{{ formatDate(post.post_date) }}</div>
                        <div class="article-list__posts-display-content-title">{{ post.title }}</div>
                    </div>
                    <a
                        aria-label=""
                        :href="post.link"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="13.657" viewBox="0 0 40 13.657">
                            <path id="Combined_Shape_Copy" data-name="Combined Shape Copy"
                                  d="M32.465,13.364a1,1,0,0,1,0-1.415l4.121-4.121H1a1,1,0,0,1,0-2H36.586L32.465,1.707A1,1,0,1,1,33.879.293L39.535,5.95a1.012,1.012,0,0,1,.08.09,1,1,0,0,1,0,1.577,1.007,1.007,0,0,1-.08.09l-5.657,5.657a1,1,0,0,1-1.414,0Z"
                                  transform="translate(0 0)"/>
                        </svg>
                    </a>
                </section>
            </div>
            <div :class="showButton ? `article-list__load-more` : `article-list__load-more hidden`">
                <button class="btn--quaternary">{{ loadMoreText }}</button>
            </div>
        </div>
    </div>
</template>

<script lang="javascript">
import lazyloader from "@pernod-ricard-global-cms/cbllazyloader";
import jsAssets from "Assets/js/modules/jsAssets";

export default {
    name: "articleList",
    data() {
        return {
            allPosts: [],
            filter: true,
            filteredPosts: [],
            newFilter: [],
            loadedCounter: 3,
            loadMoreIncrement: 3,
            allText: "",
            allCategories: [],
            categoryButtons: [],
            preview: false,
            loadMoreButton: "",
            showButton: false,
            filterDropDownIsOpen: false,
            sortDropDownIsOpen: false,
            sortDir: false,
            thumbnailOverlay: true,
            locale: "",
            sortByText: "",
            filterByText: "",
            dateAddedText: "",
            popularityText: "",
            selectedCategory: "",
            sortedBy: "",
            window: {
                width: 0
            }
        };
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    beforeMount() {
        this.preview = !!this.$parent.ispreview;
        this.allPosts = JSON.parse(this.$parent.posts);
        this.hideArticleCategories = (this.$parent.hidearticlecategories == true) ? true : false;
        this.allCategories = JSON.parse(
            this.$parent.allcategories
        );
        this.allText = this.$parent.alltext;
        this.loadMoreText = this.$parent.loadmoretext;
        this.locale = this.$parent.locale;
        this.sortByText = this.$parent.sortbytext;
        this.filterByText = this.$parent.filterbytext;
        this.thumbnailOverlay = this.$parent.thumbnailoverlay;
        this.dateAddedText = this.$parent.dateaddedtext;
        this.alphabeticalText = this.$parent.alphabeticaltext;
        this.popularityText = this.$parent.popularitytext;
        this.selectedCategory = this.allCategories[0];
        this.loadedCounter = this.window.width > 768 ? 6 : 3;
        this.loadMoreIncrement = this.window.width > 768 ? 6 : 3;
        this.sortedBy = this.dateAddedText;

    },
    mounted() {
        this.categoryButtons = this.$el.querySelectorAll(
            ".article-list__category-button"
        );
        this.selectCategory(this.allCategories[0]);
        this.applyFilter('all');

        this.loadMoreButton = this.$el.querySelector(".article-list__load-more button");
        this.loadMoreButton.addEventListener("click", () => this.loadMore());
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
        },
        applyFilter(categoryId) {
            if (categoryId === "all") {
                this.filteredPosts = this.allPosts.slice(0, this.loadedCounter);
                this.newFilter = this.allPosts;
            } else {
                this.newFilter = this.allPosts.filter((post) => {
                    return post.post_category.term_id === categoryId;
                });
                this.filteredPosts = this.newFilter.slice(0, this.loadedCounter);
            }
            this.fireLazyloader();
            this.checkForMorePosts();
        },
        checkForMorePosts() {
            this.showButton = this.loadedCounter < this.newFilter.length;
        },
        fireLazyloader() {
            if (this.preview === false) {
                this.$nextTick(function () {
                    lazyloader.options.assetArray = jsAssets.dynamicAssets;
                    lazyloader.lazyloaderInit();
                });
            }
        },
        selectCategory(category) {
            this.selectedCategory = category;
            this.categoryButtons.forEach((categoryButton) => {
                categoryButton.classList.remove("selected");
            });
            this.$el.querySelector(`.${category.slug}`).classList.add("selected");
        },
        loadMore() {
            this.loadedCounter += this.loadMoreIncrement;
            this.filteredPosts = this.newFilter.slice(0, this.loadedCounter);
            this.checkForMorePosts();
            this.fireLazyloader();
        },
        formatDate(date) {
            if (date) {
                return new Date(date.replace(/-/g, "/")).toLocaleDateString(
                    this.locale,
                    {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                    }
                );
            }
        },
        sortBy(ordering) {
            switch (ordering) {
                case "order-popular":
                    this.sortedBy = this.popularityText;
                    let sortDir = this.sortDir;
                    this.filteredPosts.sort(function (a, b) {
                        let ret =  a.post_views_count < b.post_views_count ? 1 :
                            a.post_views_count > b.post_views_count ? -1 : 0;
                        if (sortDir) {
                            return ret * -1;
                        }
                        return ret;
                    });

                    break;
                case "post-date":
                default:
                    this.sortedBy = this.dateAddedText;
                    this.filteredPosts.sort(function (a, b) {
                        return new Date(b.post_date) - new Date(a.post_date) ? 1 : -1;
                    });
                    break;
            }
        }
    },
};
</script>
